import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import * as CONST from '../../common/const';
import { DatePicker, ActionSheet, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less';

const PageModel = props => {
	const [Info, setInfo] = useState('');
	const getInfo = async (id) => {
		const result = await Request.get({
			url: '/upkeep/getupkeepdetail',
			data: {
				id
			}
		});
		if (!result) return;
		setInfo(result.data);
	};

	useEffect(() => {
		const { id } = props.match.params;
		console.log('传过来的;', id);
		if (id) {
			//获取当前微信用户绑定的店铺所有设备的保养记录
			getInfo(id)
		}

	}, [123]);
	return (
		<Page {...{ page: 'upkeepinfo', showFooter: false, title: '详情' }} {...props}>
			<section className="upkeepdetail-baoyang">
				<div className='title'>{Info.uptype == '1' ?  '保养详情' : '维修详情'}</div>
				<div className='xian'></div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">上报日期</div>
					<div className="upkeepdetail-baoyang-content">{Info ? Info.equipmentUpkeepDays : ''}</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">单位</div>
					<div className="upkeepdetail-baoyang-content">{Info ? Info.upcomany : ''}</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">操作者</div>
					<div className="upkeepdetail-baoyang-content">{Info ? Info.upname : ''}</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">联系电话</div>
					<div className="upkeepdetail-baoyang-content">{Info ? Info.uptel : ''}</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">项目</div>
				</div>
				<div className="upkeepdetail-baoyang-container-div">
					{
						Info && Info.upcontent.length > 0 && Info.upcontent.map((item, index) => {
							return (
								<div key={index} className={`upkeepdetail-item select`}>{item}</div>
							)
						})
					}
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">备注说明</div>
					<div className="upkeepdetail-baoyang-content">{Info ? Info.updesc : ''}</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">店铺门脸照</div>
					<div className="upkeepdetail-baoyang-content">
						{
							Info && Info.companyfile &&
							<img src={CONST.imgPrefix + Info.companyfile} alt="" />
						}
						{
						     !Info.companyfile && 
							<label className="upkeepdetail-baoyang-content-label">暂无</label>
						}
					</div>
				</div>
				<div className="upkeepdetail-baoyang-container">
					<div className="upkeepdetail-baoyang-title">照片</div>
					<div className="upkeepdetail-baoyang-content">
						{
							Info && Info.upfile && Info.upfile.split(',').length > 0 && Info.upfile.split(',').map((item, index) => {
								return (
									<img key={index} src={CONST.imgPrefix + item} alt="" />
								)
							})
						}
					</div>
				</div>

			</section>
		</Page>
	);
};

export default PageModel;
